import { buttonObj } from "./RequestBarConstants";
import { RequestStatus } from "../../helpers";

export const getRequestBarContent = (requestBarObj) => {
  if (requestBarObj == null) {
    return [];
  }
  const btnArr = buttonObj.map((item) => {
    let disabledVal = false;
    if (
      Array.isArray(item.status) &&
      item.status.indexOf(requestBarObj.status) === -1
    ) {
      disabledVal = true;
    }
    if (
      typeof item.status === "string" &&
      item.status !== "All" &&
      item.status.indexOf(requestBarObj.status) === -1
    ) {
      disabledVal = true;
    }
    if (item.status === "All" && requestBarObj.status !== "") {
      disabledVal = false;
    }
    if (item.status === "All" && requestBarObj.status === "") {
      disabledVal = true;
    }
    return {
      ...item,
      disabled: disabledVal,
      requestNumber: requestBarObj.requestNumber,
      obj: requestBarObj.obj || {}
    };
  });
  const statusObj = {
    value: RequestStatus[requestBarObj.status]
  };
  return [statusObj, ...btnArr];
};
